import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./IconButton.module.less";

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  active?: boolean;
  pressed?: boolean;
  "data-tooltip"?: boolean;
  disabled?: boolean;
  type?: "submit" | "reset" | "button";
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
}

type Filter<T, U> = T extends U ? T : never;

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ disabled, type = "button", className, onClick, onKeyDown, children, ...rest }, ref) => {
    const onKeyDownHandler = (event: React.KeyboardEvent<HTMLButtonElement>): void => {
      if (event.key === " " || event.key === "Enter") {
        if (onClick) {
          event.preventDefault();
          onClick(event as Filter<React.KeyboardEvent<HTMLButtonElement>, React.MouseEvent<HTMLButtonElement>>);
        }
      }
      if (onKeyDown) {
        onKeyDown(event);
      }
    };

    const buttonClass = cls(
      {
        [styles.iconButton]: true,
        [styles.iconButtonDisabled]: disabled,
      },
      className
    );

    return (
      <button
        {...rest}
        ref={ref}
        // eslint-disable-next-line react/button-has-type
        type={type}
        className={buttonClass}
        disabled={disabled}
        onClick={onClick}
        onKeyDown={onKeyDownHandler}
      >
        {children}
      </button>
    );
  }
);

export default IconButton;
